(ns dre.app.views
  (:require
   ["antd" :refer [ConfigProvider]]
   [dre.components.flash.views :as flash]
   [dre.modals.views :as modals]
   [dre.pages.views :as pages]
   [dre.panels.views :as panels]
   [dre.processes.bootstrap :as bs]
   [re-frame.core :as rf]))


(defn view
  []
  ;; check each 30 min if user is logged in
  (js/setInterval (fn [] (rf/dispatch [::bs/check-auth-periodical])) 1800000)
  [:> ConfigProvider
   {:theme {:cssVar {:key "ant-theme" :prefix "ant"} :hashed false}}
   [:<>
    [#'pages/view]
    [#'panels/view]
    [#'modals/view]
    [#'flash/view]]])
